import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popover } from 'antd';

const Notes = ({ notes }) => (
  <div className="bhp-assignment-notes">
    <Popover placement="topRight" title="Notes" content={notes} trigger="hover">
      <Icon type="info-circle" />
    </Popover>
  </div>
);

Notes.propTypes = {
  notes: PropTypes.string
};

Notes.defaultProps = {
  notes: ''
};

export default Notes;
